import { render } from "./TotalSalesForTheCurrentMonth.vue?vue&type=template&id=c74b9d7c"
import script from "./TotalSalesForTheCurrentMonth.vue?vue&type=script&lang=js"
export * from "./TotalSalesForTheCurrentMonth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__